(function() {
	'use strict';
	angular.module('app.setup')
		.controller('poStatusCategoryForm', poStatusCategoryForm);

	poStatusCategoryForm.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'poStatusCategoryService'];
	function poStatusCategoryForm($scope, $rootScope, $timeout, $filter, poStatusCategoryService) {
		var vm = this;
		// view model functions
		vm.poStatusCategory = null;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		init();
		
		function init() {
			vm.poStatusCategory = {};
		}

		function save() {
			poStatusCategoryService.addPoStatusCategory(vm.poStatusCategory).then(function(message) {
				$scope.result(message, message == 'Supply Order Status Category created successfully');
			});
		}

		function close() {
			$scope.result('', false);
		}
	}
})();
